var moment = require('moment');
moment.locale('bg');

const urlParser = document.createElement('a');

module.exports = {
	domain (url) {
		urlParser.href = url;
		return urlParser.hostname;
	},

	count (arr) {
		return arr.length;
	},

	prettyDate (date) {
		return moment(date).format('DD.MM.YYYY');
	},

	prettyDateTime (utc) {
		return moment(utc).format('DD.MM.YYYY HH:mm');
	},

	fromNowDateTime (utc) {
		return moment(utc).fromNow();
	},

	pluralize (time, label) {
		if (time === 1) {
			return time + label;
		}

		return time + label + 's';
	},

	nl2br (text) {
		return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
	}
};



// WEBPACK FOOTER //
// ./src/filters/index.js